// extracted by mini-css-extract-plugin
module.exports = {"gallerySideBySide":"VerticalMasonry_gallerySideBySide__z9dIP","imgWrapper":"VerticalMasonry_imgWrapper__NOcyW"};